// OTM 6000 X 多点吸光度表头规则
// 表头 = f(检测项目 testing_unique, 方法学 method)：两者有值就按对应版式显示，样本类型完全不参与判断
// 同一「项目 + 方法学」若配了多条，取第一条
// 命中返回表头版式 'layoutA' / 'layoutB' / 'layoutC' / 'layoutD'，未命中返回 ''
export const OTM_ABS_RULES = [
  // layoutA：p0-p6(无意义) | p7(水空白) | p8(杯空白) | p9-p10(加R1后) | p11-p13(加样品搅拌后) | p14-p38(加R2搅拌后)
  { testing: ['hs-CRP', 'SAA', 'PCT'], method: ['透射'], mode: 'layoutA' },
  // { testing: ['HbA1c'], method: ['透射'], mode: 'layoutA' },
  // { testing: ['D-dimer', 'DD'], method: ['透射'], mode: 'layoutA' },
  // layoutB：p0(水空白) | p1(杯空白) | p2-p3(加R3后) | p4-p6(加样品搅拌后) | p7(水空白) | p8(杯空白) | p9-p10(加R1后) | p11-p13(加样品搅拌后) | p14-p38(加R2搅拌后)
  { testing: ['hs-CRP', 'SAA'], method: ['散射'], mode: 'layoutB' },
  // layoutC：mALB，主波长拆 p9/p10，搅拌段 p11-p13
  // { testing: ['mALB'], method: ['散射', '透射'], mode: 'layoutC' },
  // layoutD：NAG，主波长拆 p9/p10，搅拌段 p11-p20、加R2 从 p21 起
  // { testing: ['NAG'], method: ['透射'], mode: 'layoutD' },
]
// 注：以前 HbA1c + 透射 有两条（「稀释样本」走 layoutA、「全血」走 layoutB），
// 样本类型不参与判断后两者无法区分，这里统一取 layoutA；要走 layoutB 就把上面 HbA1c 那条的 mode 改成 layoutB

// 取值转字符串并去空格：null / undefined / '' / '   ' 统一视为「无值」
const toText = v => String(v == null ? '' : v).trim()

// 展示前置条件：检测项目、方法学都必须有值，缺任何一个都不展示主/副波长多点吸光度
export const hasRequiredOtmAbsFields = (testingUnique, method) => {
  return !!toText(testingUnique) && !!toText(method)
}

export const matchOtmAbsMode = (testingUnique, method) => {
  const testing = toText(testingUnique)
  const methodText = toText(method)
  // 检测项目 / 方法学 任一无值，直接不命中（只判断这两个，样本类型不参与）
  if (!hasRequiredOtmAbsFields(testing, methodText)) return ''
  const rule = OTM_ABS_RULES.find(item =>
    item.method.some(m => methodText.includes(m)) &&
    item.testing.some(t => t.toLowerCase() === testing.toLowerCase())
  )
  return rule ? rule.mode : ''
}

// 是否命中 OTM 6000 X 的表头规则，未命中则不展示主/副波长多点吸光度
export const isOtmAbsMatched = (testingUnique, method) => {
  return !!matchOtmAbsMode(testingUnique, method)
}
